<template>
  <a-alert :type="alertType" :style="{margin: '12px 0 12px 0'}" v-if="show">
    <div slot="message">
      <a-icon type="info-circle" :style="{color: color}" />
      <span :style="{marginLeft: '10px'}"> {{$t('common.hasSelect')+selectedCount+$t('common.selectedUnit')}}</span>
      <a :style="{marginLeft: '20px', color: color}" @click="onClear">{{$t('actionTitles.clearAll')}}</a>
    </div>
  </a-alert>
</template>

<script>
export default {
  name: "ClearSelected",
  props: {
    alertType: {
      type: String,
      default: "info",
    },
    show: {
      type: Boolean,
      default: false,
    },
    selectedCount: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: {
    color() {
      switch (this.alertType) {
        case "info":
          return "rgba(24, 144, 255, 1)";
        case "success":
          return "#b7eb8f";
        case "warning":
          return "#ffe58f";
        case "error":
          return "rgba(245, 87, 78, 1)";
      }

      return "";
    },
  },
  methods: {
    onClear() {
      this.$emit("clear");
    },
  },
};
</script>